import languageModel from "../../models/language.model";

/**
 * ToggleButtonGroupComponent
 * 
 * A button group of button-like checkbox or radio toggle buttons
 * 
 * @author CV Leong
 */
export default function ToggleButtonGroupComponent() {

  const COMPONENT_ID = `ToggleButtonGroupComponent-${uniqueInstance++}`

  return {
    view: ({ attrs: { ariaLabel, buttonType, buttons = [], disabled = false, inline = false, name, onChange, required = false } }) => {
      return [
        m('.btn-group', {
          'aria-label': ariaLabel,
          'class': inline === true ? 'd-inline-block' : 'd-flex',
          'role': 'group',
        },
          buttons?.map((button) => [
            m('input.btn-check', {
              autocomplete: 'off',
              checked: button.checked,
              disabled,
              id: button.id, // mandatory
              name: name || COMPONENT_ID,
              onchange: onChange,
              required,
              type: buttonType,
              value: button.value,
            }),
            m('label.btn.btn-outline-primary', {
              for: button.id,
              onclick: onclick,
              style: 'flex: 1;',
            }, button.label)
          ]),
          // Empty state
          (!buttons || buttons.length === 0) &&
          m('input.form-control.text-center', {
            disabled: true,
            value: languageModel.getText('LT00001076', 'No data'),
          })
        )
      ]
    }
  }
}

let uniqueInstance = 1;

/**
 * Button Types for `ToggleButtonGroupComponent`
 */
export const BUTTON_TYPE = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
}
